import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ContactUs, AddContactUsParams } from '../contact-us.model';

export enum ContactUsActionTypes {
  AddContactUs = '[ContactUs] Add ContactUs'
}

export class AddContactUs implements Action {
  readonly type = ContactUsActionTypes.AddContactUs;
  constructor(public payload: AddContactUsParams) {}
}

export type ContactUsActions =
 AddContactUs;
